var map = {
	"./Bootstrap_logo.svg": "5b30",
	"./Figma-logo.svg": "d0c4",
	"./HTML5-logo.svg": "203a",
	"./Javascript-logo.svg": "3ac8",
	"./Sass_Logo.svg": "7cd6",
	"./Vue.js-logo.svg": "d909",
	"./behance.svg": "d336",
	"./bootstrap-5-1.svg": "0e6a",
	"./close-icon.svg": "dd18",
	"./codepen.svg": "5504",
	"./firebase-logo.svg": "84f5",
	"./gsap-greensock.svg": "cca4",
	"./illustrator-logo.svg": "ee8a",
	"./linkedinsvg.svg": "8e53",
	"./photoshop-logo.svg": "1bf9",
	"./web-coding.svg": "d437",
	"./website.svg": "1bc7",
	"./xd-logo.svg": "90dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9500";